var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.componentReady ? _c('div', [_c('div', {
    attrs: {
      "id": "incident-investigation-initial-report-wrapper",
      "data-test": "outside-vif"
    }
  }, [_c('button', {
    attrs: {
      "id": "intialReportToggleButton"
    },
    on: {
      "click": function ($event) {
        _vm.showInitialReport = !_vm.showInitialReport;
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.intialReportToggleLabel) + "\n    ")]), _vm._v(" "), _vm.investigation && _vm.showInitialReport ? _c('fieldset', [_c('legend', [_vm._v("Initial Report")]), _vm._v(" "), _c('IncidentReportView', {
    attrs: {
      "report-uuid": _vm.investigation.field_incident_report.id,
      "show-investigate-button": false
    }
  })], 1) : _vm._e()]), _vm._v(" "), _vm.hasErrors ? [_c('div', {
    key: _vm.hasErrors,
    staticClass: "messages error messages--error"
  }, [_c('b', [_vm._v("Please correct the following error(s):")]), _vm._v(" "), _c('ul', _vm._l(_vm.getErrors, function (error) {
    return _c('li', [_vm._v("\n          " + _vm._s(error) + "\n        ")]);
  }), 0)])] : _vm._e(), _vm._v(" "), _c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submitEntity.apply(null, arguments);
      }
    }
  }, [_vm._l(_vm.fieldGroups, function (group) {
    return [group.parent_name === '' || group.format_type === 'accordion_item' ? _c('field-group', {
      key: group.group_id,
      attrs: {
        "group-id": group.group_id,
        "group-type": group.format_type,
        "group-label": group.label,
        "group-config": group,
        "disabled": _vm.isClosed
      }
    }, [group.group_id === 'group_inc_invest_bls_code_asgmnt' ? _c('BlsCodeSelects', {
      key: group.group_id + '_bls_selects',
      attrs: {
        "values": _vm.selectedBlsCodes,
        "disabled": _vm.isClosed
      },
      on: {
        "bls-code-selection": function ($event) {
          return _vm.handleBlsCodeSelection($event);
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm._l(_vm.getChildFields(group.children), function (childElement) {
      var _vm$investigation;
      return [_vm.isChildNestedGroup(childElement) ? _c('field-group', {
        key: childElement.group_id + '-' + childElement.label,
        attrs: {
          "group-id": childElement.group_id,
          "group-type": childElement.format_type,
          "group-label": childElement.label,
          "group-config": childElement,
          "disabled": _vm.isClosed
        }
      }, [childElement.group_id === 'group_corr_prev_actions_listing' ? [_c('corrective-actions-listing', {
        key: childElement.group_id,
        attrs: {
          "investigation-uuid": _vm.uuid,
          "disabled": _vm.isClosed
        }
      })] : _vm._e(), _vm._v(" "), _vm._l(_vm.getChildFields(childElement.children), function (subChildElement) {
        return [subChildElement.field_name === 'field_inc_invest_person_involved' ? _c('user-lookup', {
          key: subChildElement.field_name,
          ref: "user-lookup",
          refInFor: true,
          attrs: {
            "field-config": subChildElement,
            "lose-name-contains": true,
            "value": _vm.selectedUser,
            "disabled": _vm.isClosed
          },
          on: {
            "userLookupSelection": _vm.userSelected
          }
        }) : subChildElement.field_name === 'field_inc_invest_group' ? _c('user-groups', {
          key: subChildElement.field_name,
          attrs: {
            "user-uuid": _vm.selectedUser ? _vm.selectedUser.id : null,
            "field-data": subChildElement,
            "field-value": _vm.selectedGroup,
            "label": "Group",
            "disabled": _vm.isClosed
          },
          on: {
            "userGroupSelected": _vm.groupSelected
          }
        }) : subChildElement.field_name === 'field_inc_invest_rep_category' ? _c('entity-form-field', {
          key: subChildElement.field_name,
          attrs: {
            "field-data": subChildElement,
            "entity": _vm.entity,
            "parent-value": _vm.formData[subChildElement.field_name],
            "entity-type": "node",
            "bundle": "incident_report",
            "placeholder": _vm.EntityFormHelper.getPlaceholder(subChildElement.field_name),
            "disabled": _vm.isClosed,
            "styled": true,
            "add-class": ['field_inc_invest_area_type_other', 'field_inc_invest_job_func_other', 'field_inc_inv_serious_inj_other'].indexOf(subChildElement.field_name > -1) ? 'hasMinWidth' : 'false'
          },
          on: {
            "update-form-data": function ($event) {
              return _vm.updateFormData($event);
            },
            "change": function ($event) {
              return _vm.handleConditionalFields($event);
            }
          }
        }) : _c('entity-form-field', {
          key: subChildElement.field_name,
          attrs: {
            "field-data": subChildElement,
            "entity": _vm.entity,
            "parent-value": _vm.formData[subChildElement.field_name],
            "entity-type": "node",
            "bundle": "incident_report",
            "no-default-value": subChildElement.field_name === 'field_inc_invest_inj_date_hired',
            "placeholder": _vm.EntityFormHelper.getPlaceholder(subChildElement.field_name),
            "hidden": _vm.isConditionallyHidden(subChildElement.field_name),
            "disabled": _vm.isClosed,
            "add-class": ['field_inc_invest_area_type_other', 'field_inc_invest_job_func_other', 'field_inc_inv_serious_inj_other'].indexOf(childElement.field_name > -1) ? 'hasMinWidth' : 'false'
          },
          on: {
            "update-form-data": function ($event) {
              return _vm.updateFormData($event);
            }
          }
        })];
      })], 2) : [group.group_id === 'group_inc_invest_file_attachment' ? _c('file-attachment-listing', {
        key: childElement.field_name + '-file-listing',
        attrs: {
          "files": (_vm$investigation = _vm.investigation) === null || _vm$investigation === void 0 ? void 0 : _vm$investigation.field_inc_invest_documents,
          "allow-file-download": "",
          "allow-file-remove": "",
          "disabled": _vm.isClosed
        }
      }) : _vm._e(), _vm._v(" "), childElement.field_name === 'field_inc_invest_documents' ? _c('raft-file-upload', {
        key: childElement.field_name,
        attrs: {
          "field-name": childElement.field_name,
          "label": childElement.label,
          "description": childElement.description,
          "field-config": childElement,
          "required": childElement.required,
          "disabled": _vm.isClosed,
          "multiple": true,
          "suppress-replace-warning": ""
        },
        on: {
          "fileUploaded": function ($event) {
            return _vm.handleFileSelectionAction($event);
          }
        }
      }) : childElement.field_name === 'field_inc_invest_root_causes' ? _c('entity-form-field', {
        key: childElement.field_name,
        attrs: {
          "field-data": childElement,
          "entity": _vm.entity,
          "parent-value": _vm.parsedRootCauses,
          "entity-type": "node",
          "bundle": "incident_report",
          "placeholder": _vm.EntityFormHelper.getPlaceholder(childElement.field_name),
          "disabled": _vm.isClosed && childElement.field_name !== 'field_inc_invest_report_status',
          "styled": true
        },
        on: {
          "update-form-data": function ($event) {
            return _vm.updateFormData($event);
          },
          "change": function ($event) {
            return _vm.handleConditionalFields($event);
          }
        }
      }) : _c('entity-form-field', {
        key: childElement.field_name,
        attrs: {
          "field-data": childElement,
          "entity": _vm.entity,
          "parent-value": _vm.formData[childElement.field_name],
          "entity-type": "node",
          "bundle": "incident_report",
          "placeholder": _vm.EntityFormHelper.getPlaceholder(childElement.field_name),
          "disabled": _vm.isClosed && childElement.field_name !== 'field_inc_invest_report_status',
          "add-class": ['field_inc_invest_area_type_other', 'field_inc_invest_job_func_other', 'field_inc_inv_serious_inj_other'].indexOf(childElement.field_name > -1) ? 'hasMinWidth' : 'false'
        },
        on: {
          "update-form-data": function ($event) {
            return _vm.updateFormData($event);
          },
          "change": function ($event) {
            return _vm.handleConditionalFields($event);
          }
        }
      })]];
    })], 2) : _vm._e()];
  }), _vm._v(" "), _c('b-form-row', {
    attrs: {
      "id": "incident-investigation-form-controls"
    }
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.submitDisabled
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmitAction();
      }
    }
  }, [_vm._v("\n        Save\n      ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.submitDisabled
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmitAndEdit();
      }
    }
  }, [_vm._v("\n        Save & Continue Editing\n      ")]), _vm._v(" "), _c('b-link', {
    attrs: {
      "href": "#",
      "disabled": _vm.isBusy
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.handleCancelAction();
      }
    }
  }, [_vm._v("\n        Cancel\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "busy-wrapper"
  }, [_vm.isBusy ? _c('raft-busy', {
    attrs: {
      "busy-text": "Saving Investigation..."
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.isDirty ? _c('div', {
    staticClass: "form-data-status"
  }, [_vm._v("\n        * You have unsaved changes to this investigation.\n      ")]) : _vm._e()], 1)], 2)], 2) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }